import * as React from "react";

import { Skeleton } from "@replo/design-system/components/skeleton/Skeleton";

export function SkeletonPreviewPlaceholder() {
  return (
    <div className="absolute inset-x-3.5 top-7 bottom-0 border-dashed border-0.5 border-border rounded-xl overflow-hidden shadow-sm opacity-50">
      <div className="bg-white flex flex-col">
        <div className="flex gap-2 p-3 pb-1.5">
          <Skeleton className="flex-1 h-20 rounded-lg" />
          <div className="flex-1 flex flex-col gap-2">
            <Skeleton className="h-8 rounded-lg" />
            <Skeleton className="flex-1 rounded-lg" />
          </div>
        </div>
        <div className="flex gap-2 px-3 py-1.5">
          <div className="flex-1 flex flex-col gap-1.5">
            <Skeleton className="h-4.5 rounded-lg" />
            <Skeleton className="flex-1 h-12 rounded-lg" />
          </div>
          <Skeleton className="flex-1 h-18 rounded-lg" />
        </div>
        <div className="flex gap-2.5 px-3 py-1.5">
          <Skeleton className="flex-1 h-18 rounded-lg" />
          <div className="flex-1 flex flex-col gap-2.5">
            <Skeleton className="h-8 rounded-lg" />
            <Skeleton className="flex-1 h-8 rounded-lg" />
          </div>
        </div>
        <div className="flex gap-2.5 px-2 py-1.5">
          <Skeleton className="w-24 h-15 rounded" />
          <div className="flex-1 flex flex-col gap-2.5">
            <Skeleton className="h-8 rounded" />
            <Skeleton className="flex-1 h-6 rounded" />
          </div>
        </div>
      </div>
    </div>
  );
}
